<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">1. 如何解决错误：打开的文件太多？</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">2. 配置trust-node和chain-id</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">3. 确保commitID是最新版本</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">What can I do if my transaction seems stuck?</a></p>
        <p @click="activeted(5)" class="s2"><a :class="{active:flag==5}" href="#box5">How long does a bridge transfer take?</a></p>
        <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">Why is the FaxChain transaction part of the bridge taking so long?</a></p>
      </div> -->
        </div>
      </div>
      <div class="p1">安装常见问题</div>
      <div id="box1" class="p2">1、如何解决错误：打开的文件太多？</div>

      <div class="p4">对于 Linux</div>
      <div class="p3">打开文件 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">/etc/sysctl.conf</span> ，添加跟随配置</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">fs.file-max = 500000</div>
        </div>
      </div>
      <div class="p3">运行命令：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">sysctl -p</div>
        </div>
      </div>
      <div class="p3">打开文件 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">/etc/security/limits.conf</span> ，添加跟随配置</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">soft nofile 65535</div>
          <div style="padding:5px 0">hard nofile 65535</div>
        </div>
      </div>
      <div class="p3">打开文件 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">/etc/systemd/system.conf</span> ，添加跟随配置</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">DefaultLimitNOFILE=65535</div>
        </div>
      </div>
      <div class="p3">重启系统，问题解决</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">reboot</div>
        </div>
      </div>

      <div class="p4">对于 MACOS</div>
      <div class="p3">如果你正在运行 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">zsh</span> ，打开文件 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">/etc/zshrc</span> ，添加跟随配置</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">ulimit -n 20480</div>
        </div>
      </div>
      <div class="p3">如果你正在运行 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">bash</span> ，打开文件 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">~/.bash_profile</span> ，添加跟随配置</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">ulimit -n 20480</div>
        </div>
      </div>

      <div class="p4">对于 docker-compose</div>
      <div class="p3">如果您使用 docker-compose 启动 exchaind，请编辑 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">compose.yml</span> 并添加</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">ulimits:</div>
          <div style="padding:5px 20px">nproc: 65535</div>
          <div style="padding:5px 20px">nofile:</div>
          <div style="padding:5px 60px">soft:65535</div>
          <div style="padding:5px 60px">hard:65535</div>
        </div>
      </div>
      <div class="p3">重新启动 docker-compose 以应用新设置</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">docker-compose -f ${compose.yml} down</div>
          <div style="padding:5px 0">docker-compose -f ${compose.yml} up -d</div>
        </div>
      </div>

      <div id="box2" class="p2">2. 配置trust-node和chain-id</div>
      <div class="p3">用于 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">exchaincli</span> 查询block/tx或发送tx时，可能会出现以下错误：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">$ exchaincli query block 6547302</div>
          <div style="padding:5px 0">panic: runtime error: invalid memory address or nil pointer dereference</div>
          <div style="padding:5px 0">[signal SIGSEGV: segmentation violation code=0x1 addr=0x0 pc=0x4cecdea]</div>
        </div>
      </div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">$ exchaincli tx send boos ex1fh9tpkqka29n0mj307cu5cvp5ts0p4dl3mkv7r 1fax -y --fees 0.002fax</div>
          <div style="padding:5px 0">ERROR: chain ID required but not specified</div>
        </div>
      </div>
      <div class="p3">你应该使用标志</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">$ exchaincli query block 6547302 --trust-node</div>
          <div style="padding:5px 0">$ exchaincli tx send boos ex1fh9tpkqka29n0mj307cu5cvp5ts0p4dl3mkv7r 1fax -y --fees 0.002fax --chain-id exchain-778787</div>
        </div>
      </div>
      <div class="p3">或本地配置</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">$ exchaincli config chain-id exchain-778787</div>
          <div style="padding:5px 0">$ exchaincli config trust-node true</div>
        </div>
      </div>

      <div id="box3" class="p2">3.确保commitID是最新版本</div>
      <div class="p3">启动自己的节点时，要确保exchaind的commitID与官方版本一致，检查方式：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">$ exchaind version --long</div>
          <div style="padding:5px 0"># or</div>
          <div style="padding:5px 0">$ docker exec docker_container_name exchaind version --long</div>
        </div>
      </div>
      <div class="p3">例如 v0.16.8.3 的 commitID 为 ee5068ccb54b464aeaff7eef69fb2e8611551fed。</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">name: faxchain</div>
          <div style="padding:5px 0">server_name: exchaind</div>
          <div style="padding:5px 0">client_name: exchaincli</div>
          <div style="padding:5px 0">version: v0.16.8.3</div>
          <div style="padding:5px 0">commit: ee5068ccb54b464aeaff7eef69fb2e8611551fed</div>
        </div>
      </div>
      
    </div>
    <div class="wrapper">
      <div class="anchor1">
        <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">1. 如何解决错误：打开的文件太多？</a></p>
        <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">2. 配置trust-node和chain-id</a></p>
        <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">3. 确保commitID是最新版本</a></p>
        <!-- <div class="subAnchor">
          <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">What can I do if my transaction seems stuck?</a></p>
          <p @click="activeted(5)" class="s2"><a :class="{active:flag==5}" href="#box5">How long does a bridge transfer take?</a></p>
          <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">Why is the FaxChain transaction part of the bridge taking so long?</a></p>
  
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaxchainBridge',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>